export default [
  /** 推荐购车 开始 */
  {
    path: '/recommend',
    name: 'recommend',
    component: () => import(/* webpackChunkName: "recommend" */ '../../views/recommendBuy/index.vue'),
    meta: {
      title: '推荐购车',
    },
  },
  {
    path: '/recommend/infoCollect',
    name: 'recommendInfoCollect',
    component: () => import(/* webpackChunkName: "infoCollect" */ '../../views/recommendBuy/Recommend.vue'),
    meta: {
      title: '推荐购车',
    },
  },
  {
    path: '/recommend/commission',
    name: 'Commission',
    component: () => import(/* webpackChunkName: "commission" */ '../../views/recommendBuy/CommissionNew.vue'),
    meta: {
      title: '我的佣金',
    },
  },
  {
    path: '/recommend/infoTip',
    name: 'infoTip',
    component: () => import(/* webpackChunkName: "infoTip" */ '../../views/recommendBuy/InfoTip.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/recommend/cashInfoInput',
    name: 'cashInfoInput',
    component: () => import(/* webpackChunkName: "cashInfoInput" */ '../../views/recommendBuy/CashInfoInput.vue'),
    meta: {
      title: '提现信息维护',
    },
  },
  {
    path: '/recommend/orderDetails',
    name: 'orderDetails',
    component: () => import(/* webpackChunkName: "orderDetails" */ '../../views/recommendBuy/OrderDetails.vue'),
    meta: {
      title: '被推荐人下单明细',
    },
  },
  {
    path: '/recommend/idcard',
    name: 'idcard',
    component: () => import(/* webpackChunkName: "idcard" */ '../../views/recommendBuy/IdCard.vue'),
    meta: {
      title: '上传身份证信息',
    },
  },
  /** 推荐购车 结束 */
]
